// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"Dashboard__dashboard___36NoD"};